/**
 * Type definitions for pools filters.
 * State management is handled by PoolsFiltersProvider + usePoolsFilters (nuqs URL state).
 */

export interface PoolFilters {
	keyword: string;
	protocol: string;
	/** Catalog display names. Empty = all networks. */
	network: string[];
	feeTier: string;
	tvl: string;
	"1dVolume": string;
	/** Min dailyized Vol/TVL (1D) threshold id, e.g. "0.2". */
	volTvl: string;
	marketCap: string;
}

export const defaultFilters: PoolFilters = {
	keyword: "",
	protocol: "all",
	network: [],
	feeTier: "all",
	tvl: "all",
	"1dVolume": "all",
	volTvl: "all",
	marketCap: "all",
};
